import { Component, OnInit, SecurityContext } from '@angular/core';
import { JhiLanguageService } from '../../shared/core-utils';
import { TranslateService } from '@ngx-translate/core';
import { GermplasmDetailsContext } from '../germplasm-details.context';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ParamContext } from '../../shared/service/param.context';
import { EMPTY_PAGE_URL, FILE_MANAGER_URL } from '../../app.constants';
import { GermplasmService } from '../../shared/germplasm/service/germplasm.service';
import { ActivatedRoute } from '@angular/router';
import { getUrl } from '../../shared/util/dev-util';
import { UrlService } from '../../shared/service/url.service';

@Component({
    selector: 'jhi-files-pane',
    templateUrl: './files-pane.component.html'
})
export class FilesPaneComponent implements OnInit {

    safeUrl: SafeResourceUrl = EMPTY_PAGE_URL;

    constructor(public languageservice: JhiLanguageService,
                public translateService: TranslateService,
                private germplasmService: GermplasmService,
                private germplasmDetailsContext: GermplasmDetailsContext,
                private paramContext: ParamContext,
                private sanitizer: DomSanitizer,
                private route: ActivatedRoute,
                private urlService: UrlService
    ) {
        this.germplasmService.getGermplasmById(this.germplasmDetailsContext.gid).toPromise().then((resp) => {
            let queryParams = '?cropName=' + paramContext.cropName
                + '&programUUID=' + paramContext.programUUID
                + '&germplasmUUID=' + resp.body.germplasmUUID
                + '&embedded=true';
            const variableName = this.route.snapshot.queryParamMap.get('variableName');
            if (variableName) {
                queryParams += '&variableName=' + variableName;
            }

            const urlStr = this.urlService.buildSafeUrl(FILE_MANAGER_URL + queryParams);
            // Fall back to a blank page if the URL is not on the allowlist.
            this.safeUrl = urlStr !== null
                ? this.sanitizer.bypassSecurityTrustResourceUrl(urlStr)
                : this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
        });

    }

    ngOnInit(): void {
    }

}
